<template>
<div class="input-group-append">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>